const QUIZ_RECOMMENDATION_CATALOG = {
  version: 2,
  previewHandles: [
    'nmn-60-capsule-x-500mg',
    'regenad-nad-booster',
    'qnight-relax-complex-somn',
    'berbersome-berberina',
    'omega-3-qmega',
    'creatina-monohidrata-300gr'
  ],
  roleOrder: ['primary', 'complementary', 'optional'],
  roleTargets: {
    primary: 2,
    complementary: 2,
    optional: 2
  },
  roleThresholdRatios: {
    primary: 0.42,
    complementary: 0.3,
    optional: 0.2
  },
  tierLabels: {
    primary: {
      title: 'Prioritare',
      description: 'Aici începe protocolul tău: cele mai bune 2 alegeri pentru obiectivul dominant.'
    },
    complementary: {
      title: 'Complementare',
      description: 'Acestea susțin direcția principală fără să dubleze inutil formula.'
    },
    optional: {
      title: 'Opționale',
      description: 'Upgrade-uri bine alese pentru contextul tău actual și pentru sănătatea pe termen lung.'
    }
  },
  answerNeedMap: {
    q1: {
      energy_focus: {
        energy: 5,
        focus: 4,
        brain: 2,
        longevity: 2
      },
      recovery_sleep: {
        sleep: 5,
        stress: 4,
        recovery: 4,
        antioxidant: 2
      },
      metabolism_form: {
        metabolism: 5,
        cardio: 4,
        body_composition: 3,
        longevity: 2
      }
    },
    q2: {
      mental_work: {
        focus: 5,
        brain: 4,
        stress: 2,
        energy: 2
      },
      stress_schedule: {
        stress: 5,
        sleep: 4,
        recovery: 3,
        antioxidant: 2
      },
      physical_effort: {
        performance: 5,
        recovery: 4,
        muscle: 4,
        joints: 3,
        energy: 2
      }
    },
    q3: {
      clarity_performance: {
        focus: 4,
        energy: 4,
        brain: 3,
        performance: 2
      },
      balance_sleep: {
        sleep: 5,
        stress: 4,
        recovery: 3
      },
      recovery_resilience: {
        recovery: 5,
        antioxidant: 4,
        performance: 3,
        longevity: 2
      }
    },
    q4: {
      sport_regular: {
        performance: 4,
        muscle: 4,
        recovery: 3,
        joints: 2
      },
      movement_occasional: {
        energy: 2,
        metabolism: 2,
        cardio: 2,
        longevity: 1
      },
      low_movement: {
        metabolism: 4,
        cardio: 3,
        energy: 1,
        longevity: 2
      }
    },
    q5: {
      brain_focus: {
        brain: 5,
        focus: 4,
        longevity: 3
      },
      metabolism_heart: {
        metabolism: 5,
        cardio: 5,
        longevity: 2
      },
      skin_joints: {
        skin: 5,
        joints: 4,
        recovery: 3,
        antioxidant: 2
      }
    },
    q6: {
      hard_morning: {
        energy: 5,
        focus: 3,
        metabolism: 2
      },
      afternoon_crash: {
        energy: 4,
        focus: 4,
        brain: 2
      },
      heavy_evening: {
        recovery: 4,
        sleep: 4,
        stress: 3,
        antioxidant: 2
      }
    }
  },
  products: [
    {
      handle: 'nmn-60-capsule-x-500mg',
      families: ['NAD', 'energie', 'longevitate'],
      roles: ['primary', 'complementary'],
      benefit: 'Punctul de start pentru energie celulară, focus și vitalitate de zi cu zi.',
      bias: 0.35,
      weights: {
        energy: 1.75,
        focus: 1.4,
        longevity: 1.35,
        brain: 0.7,
        recovery: 0.2,
        metabolism: 0.2
      },
      boosts: [
        {
          when: {
            q1: ['energy_focus'],
            q6: ['hard_morning']
          },
          score: 3.2
        },
        {
          when: {
            q2: ['mental_work'],
            q5: ['brain_focus']
          },
          score: 1.4
        }
      ]
    },
    {
      handle: 'regenad-nad-booster',
      families: ['NAD+', 'energie', 'healthy aging'],
      roles: ['primary', 'complementary'],
      benefit: 'Boost orientat pe NAD+, potrivit când vrei randament susținut în perioade solicitante.',
      bias: 0.3,
      weights: {
        energy: 1.65,
        focus: 1.45,
        longevity: 1.45,
        brain: 0.9,
        recovery: 0.3,
        cardio: 0.2
      },
      boosts: [
        {
          when: {
            q1: ['energy_focus'],
            q3: ['clarity_performance']
          },
          score: 3.1
        },
        {
          when: {
            q6: ['afternoon_crash']
          },
          score: 1.2
        }
      ]
    },
    {
      handle: 'omega-3-qmega',
      families: ['Omega-3', 'creier', 'cardio'],
      roles: ['complementary', 'optional'],
      benefit: 'Aduce Omega-3 premium pentru creier, inimă și recuperare mai curată.',
      bias: 0.22,
      weights: {
        brain: 1.25,
        cardio: 1.35,
        recovery: 0.85,
        longevity: 0.7,
        focus: 0.4,
        skin: 0.35
      },
      boosts: [
        {
          when: {
            q5: ['brain_focus']
          },
          score: 1.4
        },
        {
          when: {
            q5: ['metabolism_heart']
          },
          score: 1.6
        }
      ]
    },
    {
      handle: 'resveratrol-veri-te-capsule-30g-60-capsule',
      families: ['antioxidant', 'longevitate', 'cardio'],
      roles: ['complementary', 'optional'],
      benefit: 'Antioxidant de referință pentru protecție celulară și îmbătrânire sănătoasă.',
      bias: 0.18,
      weights: {
        antioxidant: 1.45,
        longevity: 1.45,
        cardio: 0.75,
        recovery: 0.35
      },
      exclusiveWith: ['resveratrol-pulbere-60-doze-30gr'],
      boosts: [
        {
          when: {
            q1: ['recovery_sleep'],
            q6: ['heavy_evening']
          },
          score: 2.2
        }
      ]
    },
    {
      handle: 'vitamina-d3-k2',
      families: ['imunitate', 'os', 'metabolism'],
      roles: ['complementary', 'optional'],
      benefit: 'Bază clasică pentru imunitate, os și utilizarea corectă a calciului.',
      weights: {
        immunity: 1.25,
        metabolism: 0.8,
        cardio: 0.55,
        joints: 0.55,
        longevity: 0.35
      },
      exclusiveWith: ['vitamina-d3-k2-capsule'],
      boosts: [
        {
          when: {
            q4: ['low_movement']
          },
          score: 1.1
        },
        {
          when: {
            q1: ['metabolism_form']
          },
          score: 0.9
        }
      ]
    },
    {
      handle: 'vitamina-d3-k2-capsule',
      families: ['imunitate', 'os', 'metabolism'],
      roles: ['complementary', 'optional'],
      benefit: 'Formulă concentrată D3 + K2, bună ca bază metabolică și de structură.',
      bias: 0.08,
      weights: {
        immunity: 1.35,
        metabolism: 0.85,
        cardio: 0.6,
        joints: 0.6,
        longevity: 0.4
      },
      exclusiveWith: ['vitamina-d3-k2'],
      boosts: [
        {
          when: {
            q4: ['low_movement']
          },
          score: 1.2
        },
        {
          when: {
            q1: ['metabolism_form']
          },
          score: 1
        }
      ]
    },
    {
      handle: 'colagen-peptide',
      families: ['piele', 'articulații', 'recuperare'],
      roles: ['complementary', 'optional'],
      benefit: 'Pune accent pe piele, articulații și refacerea țesuturilor solicitate.',
      weights: {
        joints: 1.8,
        skin: 1.7,
        recovery: 1.1,
        performance: 0.45
      },
      boosts: [
        {
          when: {
            q5: ['skin_joints']
          },
          score: 4.2
        },
        {
          when: {
            q2: ['physical_effort'],
            q5: ['skin_joints']
          },
          score: 2.6
        }
      ]
    },
    {
      handle: 'glynac-glicina-n-acetil-cisteina',
      families: ['recuperare', 'antioxidant', 'longevitate'],
      roles: ['primary', 'complementary'],
      benefit: 'Formulă orientată spre glutation, protecție celulară și recuperare din stres oxidativ.',
      bias: 0.18,
      weights: {
        recovery: 1.35,
        antioxidant: 1.45,
        longevity: 0.8,
        stress: 0.65,
        performance: 0.25
      },
      boosts: [
        {
          when: {
            q1: ['recovery_sleep'],
            q6: ['heavy_evening']
          },
          score: 2.8
        },
        {
          when: {
            q3: ['recovery_resilience']
          },
          score: 1.4
        }
      ]
    },
    {
      handle: 'quercesome-capsule-cu-quercetina',
      families: ['antioxidant', 'imunitate', 'reziliență'],
      roles: ['complementary', 'optional'],
      benefit: 'Quercetină cu absorbție bună, utilă pentru apărare antioxidantă și confort sezonier.',
      weights: {
        antioxidant: 1.1,
        recovery: 0.6,
        immunity: 0.8,
        stress: 0.45
      },
      boosts: [
        {
          when: {
            q1: ['recovery_sleep'],
            q2: ['stress_schedule'],
            q3: ['balance_sleep']
          },
          score: 2.6
        }
      ]
    },
    {
      handle: 'berbersome-berberina',
      families: ['metabolism', 'glicemie', 'cardio'],
      roles: ['primary', 'complementary'],
      benefit: 'Țintă clară pe metabolism, glicemie și control mai bun al energiei după mese.',
      bias: 0.28,
      weights: {
        metabolism: 1.75,
        cardio: 0.95,
        energy: 0.35,
        longevity: 0.4
      },
      boosts: [
        {
          when: {
            q1: ['metabolism_form'],
            q5: ['metabolism_heart']
          },
          score: 3.5
        },
        {
          when: {
            q6: ['afternoon_crash']
          },
          score: 0.8
        }
      ]
    },
    {
      handle: 'nmn-serum',
      families: ['piele', 'beauty', 'healthy aging'],
      roles: ['optional'],
      benefit: 'Ser concentrat pentru luminozitate, hidratare și aspect mai neted al pielii.',
      requires: {
        q5: ['skin_joints']
      },
      weights: {
        skin: 1.9,
        antioxidant: 0.45
      },
      boosts: [
        {
          when: {
            q5: ['skin_joints']
          },
          score: 4.8
        }
      ]
    },
    {
      handle: 'tmg-betaina',
      families: ['metilare', 'energie', 'protocol NAD'],
      roles: ['complementary', 'optional'],
      benefit: 'Completează elegant protocolul NMN prin suport pe metilare și echilibru biochimic.',
      weights: {
        energy: 0.95,
        longevity: 0.65,
        focus: 0.35,
        metabolism: 0.4
      },
      boosts: [
        {
          when: {
            q1: ['energy_focus']
          },
          score: 1.4
        },
        {
          when: {
            q6: ['afternoon_crash']
          },
          score: 1
        }
      ]
    },
    {
      handle: 'nmn-pulbere-30-de-porții',
      families: ['NAD', 'energie', 'sport'],
      roles: ['complementary', 'optional'],
      benefit: 'Format flexibil, ușor de dozat, pentru cei care vor control mai fin sau protocol sportiv.',
      weights: {
        energy: 1.55,
        focus: 1.1,
        longevity: 1.2,
        performance: 0.7,
        recovery: 0.25
      },
      exclusiveWith: ['nmn-60-capsule-x-500mg'],
      boosts: [
        {
          when: {
            q2: ['physical_effort'],
            q4: ['sport_regular']
          },
          score: 3.6
        },
        {
          when: {
            q1: ['energy_focus']
          },
          score: 0.8
        }
      ]
    },
    {
      handle: 'creatina-monohidrata-300gr',
      families: ['performanță', 'forță', 'recuperare'],
      roles: ['primary', 'complementary'],
      benefit: 'Alegerea directă pentru forță, explozie și refacere musculară mai rapidă.',
      bias: 0.2,
      weights: {
        performance: 1.85,
        muscle: 1.85,
        recovery: 1.1,
        brain: 0.45,
        energy: 0.35
      },
      boosts: [
        {
          when: {
            q2: ['physical_effort'],
            q4: ['sport_regular']
          },
          score: 4
        },
        {
          when: {
            q3: ['recovery_resilience']
          },
          score: 1.1
        }
      ]
    },
    {
      handle: 'magneziu-l-treonat',
      families: ['magneziu', 'creier', 'somn'],
      roles: ['primary', 'complementary'],
      benefit: 'Merge bine când vrei calm neurologic, minte mai clară și suport pentru focus.',
      weights: {
        brain: 1.55,
        focus: 1.25,
        sleep: 0.95,
        stress: 0.8,
        recovery: 0.25
      },
      exclusiveWith: [
        'magneziu-bisglicinat-moleqlar',
        'cognesium-magneziu-l-threonat-bisglicinat-60-capsule'
      ],
      boosts: [
        {
          when: {
            q2: ['mental_work'],
            q5: ['brain_focus']
          },
          score: 3
        },
        {
          when: {
            q1: ['recovery_sleep']
          },
          score: 0.8
        }
      ]
    },
    {
      handle: 'magneziu-bisglicinat-moleqlar',
      families: ['magneziu', 'somn', 'stres'],
      roles: ['primary', 'complementary'],
      benefit: 'Variantă cu toleranță foarte bună când vrei relaxare, stres mai mic și somn mai curat.',
      weights: {
        sleep: 1.55,
        stress: 1.6,
        recovery: 0.65,
        brain: 0.35
      },
      exclusiveWith: [
        'magneziu-l-treonat',
        'cognesium-magneziu-l-threonat-bisglicinat-60-capsule'
      ],
      boosts: [
        {
          when: {
            q1: ['recovery_sleep'],
            q3: ['balance_sleep']
          },
          score: 3.2
        },
        {
          when: {
            q6: ['heavy_evening']
          },
          score: 1.4
        }
      ]
    },
    {
      handle: 'cognesium-magneziu-l-threonat-bisglicinat-60-capsule',
      families: ['magneziu', 'cogniție', 'somn funcțional'],
      roles: ['primary', 'complementary'],
      benefit: 'Mix modern pentru focus, stres cognitiv și seri mai liniștite fără senzație de supraîncărcare.',
      bias: 0.15,
      weights: {
        brain: 1.7,
        focus: 1.55,
        stress: 0.85,
        sleep: 0.6,
        recovery: 0.2
      },
      exclusiveWith: [
        'magneziu-l-treonat',
        'magneziu-bisglicinat-moleqlar'
      ],
      boosts: [
        {
          when: {
            q2: ['mental_work'],
            q5: ['brain_focus']
          },
          score: 3.4
        },
        {
          when: {
            q2: ['stress_schedule'],
            q3: ['balance_sleep']
          },
          score: 2
        }
      ]
    },
    {
      handle: 'resveratrol-pulbere-60-doze-30gr',
      families: ['antioxidant', 'longevitate', 'flexibilitate dozaj'],
      roles: ['optional'],
      benefit: 'Variantă pudră pentru dozaj flexibil și protecție antioxidantă constantă.',
      weights: {
        antioxidant: 1.4,
        longevity: 1.35,
        cardio: 0.7,
        recovery: 0.4
      },
      exclusiveWith: ['resveratrol-veri-te-capsule-30g-60-capsule'],
      boosts: [
        {
          when: {
            q1: ['recovery_sleep'],
            q3: ['recovery_resilience'],
            q6: ['heavy_evening']
          },
          score: 3.2
        }
      ]
    },
    {
      handle: 'qnight-relax-complex-somn',
      families: ['somn', 'relaxare', 'recuperare'],
      roles: ['primary', 'complementary'],
      benefit: 'Când somnul și resetarea sunt prioritatea numărul unu, acesta este unul dintre cele mai directe răspunsuri.',
      bias: 0.28,
      weights: {
        sleep: 1.85,
        stress: 1.65,
        recovery: 0.9,
        brain: 0.25
      },
      boosts: [
        {
          when: {
            q1: ['recovery_sleep'],
            q3: ['balance_sleep']
          },
          score: 4.1
        },
        {
          when: {
            q6: ['heavy_evening']
          },
          score: 1.5
        }
      ]
    },
    {
      handle: 'lipolyzer-monacolin-k',
      families: ['cardio', 'colesterol', 'metabolism'],
      roles: ['primary', 'complementary'],
      benefit: 'Opțiune foarte țintită pentru profil metabolic și suport cardiovascular.',
      weights: {
        cardio: 1.75,
        metabolism: 1.45,
        longevity: 0.55
      },
      boosts: [
        {
          when: {
            q1: ['metabolism_form'],
            q5: ['metabolism_heart']
          },
          score: 3.4
        }
      ]
    },
    {
      handle: 'vitamina-c-liposomala',
      families: ['imunitate', 'antioxidant', 'reziliență'],
      roles: ['complementary', 'optional'],
      benefit: 'Un suport versatil pentru imunitate, apărare antioxidantă și perioade solicitante.',
      weights: {
        immunity: 1.55,
        antioxidant: 1.2,
        recovery: 0.75,
        skin: 0.3
      },
      boosts: [
        {
          when: {
            q1: ['recovery_sleep']
          },
          score: 1.1
        },
        {
          when: {
            q6: ['heavy_evening']
          },
          score: 1.1
        }
      ]
    },
    {
      handle: 'prolithin-a-urolithin-a',
      families: ['mitocondrii', 'recuperare', 'healthy aging'],
      roles: ['complementary', 'optional'],
      benefit: 'Interesant când vrei mitocondrii mai reziliente și recuperare mai bine susținută.',
      weights: {
        recovery: 1.15,
        longevity: 1.45,
        performance: 0.9,
        muscle: 0.55,
        antioxidant: 0.45
      },
      boosts: [
        {
          when: {
            q2: ['physical_effort'],
            q3: ['recovery_resilience']
          },
          score: 2
        },
        {
          when: {
            q4: ['sport_regular']
          },
          score: 0.6
        }
      ]
    },
    {
      handle: 'amino-acizi-esentiali',
      families: ['aminoacizi', 'sport', 'recuperare'],
      roles: ['complementary', 'optional'],
      benefit: 'Foarte utili când vrei să ridici calitatea recuperării și aportul funcțional de aminoacizi.',
      weights: {
        muscle: 1.7,
        recovery: 1.45,
        performance: 1.35,
        energy: 0.3
      },
      boosts: [
        {
          when: {
            q2: ['physical_effort'],
            q4: ['sport_regular']
          },
          score: 3.4
        },
        {
          when: {
            q3: ['recovery_resilience']
          },
          score: 1.1
        }
      ]
    },
    {
      handle: 'enhanced-protein-pulbere',
      families: ['proteină', 'recuperare', 'compoziție corporală'],
      roles: ['primary', 'complementary'],
      benefit: 'Proteină îmbunătățită, cu profil mai premium decât o pudră simplă, bună pentru recuperare și compoziție corporală.',
      bias: 0.12,
      weights: {
        muscle: 1.7,
        recovery: 1.5,
        performance: 1.15,
        metabolism: 0.55,
        energy: 0.2
      },
      boosts: [
        {
          when: {
            q2: ['physical_effort'],
            q4: ['sport_regular']
          },
          score: 3.3
        },
        {
          when: {
            q3: ['recovery_resilience']
          },
          score: 1
        }
      ]
    },
    {
      handle: 'ergotioneina',
      families: ['antioxidant', 'creier', 'healthy aging'],
      roles: ['complementary', 'optional'],
      benefit: 'Bună pentru cine vrea un antioxidant premium cu poveste puternică pe protecție celulară și healthy aging.',
      weights: {
        antioxidant: 1.6,
        longevity: 1.45,
        brain: 1.15,
        cardio: 0.45
      },
      boosts: [
        {
          when: {
            q5: ['brain_focus']
          },
          score: 1.6
        },
        {
          when: {
            q1: ['recovery_sleep']
          },
          score: 1.1
        }
      ]
    },
    {
      handle: 'valasta-liquid-astaxanthin-olive-oil-100ml',
      families: ['astaxantină', 'antioxidant', 'healthy aging'],
      roles: ['complementary', 'optional'],
      benefit: 'Antioxidant premium în formă lichidă, potrivit când vrei un upgrade clar pe protecție celulară și rutină premium.',
      weights: {
        antioxidant: 1.8,
        longevity: 1.4,
        skin: 0.85,
        cardio: 0.55,
        brain: 0.45
      },
      boosts: [
        {
          when: {
            q5: ['skin_joints']
          },
          score: 1.8
        },
        {
          when: {
            q1: ['recovery_sleep']
          },
          score: 1.2
        }
      ]
    },
    {
      handle: 'coenzima-q10-moleqlar',
      families: ['energie', 'cardio', 'mitocondrial'],
      roles: ['complementary', 'optional'],
      benefit: 'Complement bun pentru inimă, energie și suport mitocondrial în perioade de randament mare.',
      weights: {
        cardio: 1.35,
        energy: 1.05,
        longevity: 0.9,
        brain: 0.45,
        performance: 0.25
      },
      boosts: [
        {
          when: {
            q5: ['metabolism_heart'],
            q6: ['afternoon_crash']
          },
          score: 2.8
        },
        {
          when: {
            q1: ['energy_focus', 'metabolism_form']
          },
          score: 1
        }
      ]
    }
  ]
};

if (typeof window !== 'undefined') {
  window.QuizRecommendationCatalog = QUIZ_RECOMMENDATION_CATALOG;
}

if (typeof module !== 'undefined') {
  module.exports = {
    QUIZ_RECOMMENDATION_CATALOG
  };
}
